// src/Component/hooks/usePostDetail_pengeluaran.jsx
import { useState } from 'react';
import api from '../Services/api';
import endpoints from '../Services/endpointAdmin';

/**
 * @returns { Object } - Mengembalikan fungsi postDetailPengeluaran, serta status loading dan error.
 */
const usePostDetailPengeluaran = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Fungsi untuk mengirim data detail pengeluaran ke backend.
   * @param { number } id_jenis_beban
   * @param { number } nominal
   * @param { string } keterangan
   * @param { number|null } id_pengeluaran
   * @returns { Promise<Object> } - Mengembalikan data respons dari backend atau error.
   */
  const postDetailPengeluaran = async (id_jenis_beban, nominal, keterangan, id_pengeluaran = null) => {
    setLoading(true);
    setError(null);

    try {
      const data = {
        id_jenis_beban,
        nominal,
        keterangan,
      };
      if (id_pengeluaran != null) {
        data.id_pengeluaran = id_pengeluaran;
      }

      const response = await api.post(endpoints.detail_pengeluaran.create, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (err) {
      console.error('Error uploading detail pengeluaran:', err);
      setError(
        err.response?.data?.error ||
        err.response?.data?.message ||
        'Terjadi kesalahan saat mengupload data detail pengeluaran.'
      );
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { postDetailPengeluaran, loading, error };
};

export default usePostDetailPengeluaran;
